import * as React from 'react';
import { Emoji } from '../Emoji';
import * as animations from '@styles/_animations.scss';

export const SpiderWeb = (props: { text?: string; position?: { x: number; y: number } }) => (
  <div
    className={[animations.animated, animations.bounceInDown].join(' ')}
    style={{
      position: 'absolute',
      top: `${props.position ? props.position.y : -3}%`,
      left: `${props.position ? props.position.x : -3}%`,
      zIndex: 20
    }}
  >
    <Emoji name={Emoji.EmojiNames.SpiderWeb} size={100} />
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/emoji/_components/SpiderWeb.tsx